import { Observable } from 'rxjs';
import {
    CartStep2InsuranceInterface,
    CartStep2InsuranceResponseInterface,
} from '../models/cart-step2-insurance.model';

export abstract class CartStep2InsuranceRepository {
    abstract sendCartStep2Insurance(
        array: CartStep2InsuranceInterface,
    ): Observable<CartStep2InsuranceResponseInterface>;
}
